<template>
  <NoProviderReference v-if="session" :error-title="t('payment-failed-message')" error-details="" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import NoProviderReference from "@/components/providers/NoProviderReference.vue";
import { ISession } from "@/types/ISession";
import authHelper from "@/helpers/authHelper";

export default defineComponent({
  name: "PaymentFailedView",
  components: { NoProviderReference },
  setup() {
    const { t } = useI18n();
    const session: ISession | null = authHelper.getSession();

    return {
      t,
      session
    };
  },
  beforeMount() {
    if(!this.session) {
      window.open("https://payjoy.com", "_self");
    }
  }
});
</script>
